import { TiChartSeriesComponent } from "../components/ti-chart-series.component";
import { ChartStyleColorModel } from "../models/chart-style/chart-style-color.model";
import { ChartStyleSettingsModel } from "../models/chart-style/chart-style-settings.model";
import { TIComparisonDataModel } from "../models/data-point/ti-comparison-data.model";
import { IndicatorColorType, TIIndicatorDataModel } from "../models/data-point/ti-indicator-data.model";
import { ChartType } from "../models/enum/chart-type.enum";
import { HighChartBuilder } from "./highchart.builder";
const color = require('../library/darken-color.js');

export class HighChartStyleBuilder {
    private element: HTMLElement;
    private highChartBuilder: HighChartBuilder;

    private chartStylePrefix = '.ti-chart.normal';
    private isMarketingMode = false;
    private isPnPMode = false;

    private chartId = '';
    constructor(tiChartSeries: TiChartSeriesComponent) {
        this.element = tiChartSeries.element;
        this.highChartBuilder = tiChartSeries.highChartBuilder;
        this.isMarketingMode = tiChartSeries.base.marketingWebChartMode;
        if (tiChartSeries.base.pnpMode) {
            this.isPnPMode = true;
            this.chartStylePrefix = '.ti-chart.pnp';
        }

        if (tiChartSeries.base.marketingWebChartMode) {
            this.chartStylePrefix += '.' + tiChartSeries.base.id;
        }

        this.chartId = tiChartSeries.base.id;
    }

    public createMainChartStyle(chartStyleSettings: ChartStyleSettingsModel) {
        let highChartStyle = this.element.querySelector('.ti-chart-style');
        if (highChartStyle) {
            highChartStyle.remove();
        }

        let styleTag = `<style>`;
        if (chartStyleSettings.isGradientChecked) {
            styleTag += `${this.chartStylePrefix} { background: linear-gradient(180deg, ${chartStyleSettings.selectedChartBackgroundColor.toRGB()}, ${chartStyleSettings.selectedChartGradientColor.toRGB()}); }`;
            styleTag += `${this.chartStylePrefix} .highcharts-background { fill:url(#tichart-bg${(this.isPnPMode ? '-pnp-' + this.chartId  : '-' + this.chartId )}); x: 0; y: 0; width: 100%; height: 100%; }`;
        } else {
            styleTag += `${this.chartStylePrefix} { background: ${chartStyleSettings.selectedChartBackgroundColor.toRGB()}; }`;
            styleTag += `${this.chartStylePrefix} .highcharts-background { fill:${chartStyleSettings.selectedChartBackgroundColor.toRGB()}; x: 0; y: 0; width: 100%; height: 100%; }`;
        }

        if (chartStyleSettings.chartType == ChartType.Candlestick) {
            styleTag += `${this.chartStylePrefix} .highcharts-candlestick-series.${this.highChartBuilder.mainSeriesClassName} .highcharts-point { stroke:${chartStyleSettings.selectedOutlineWickColor.toRGB()}; }`;

            if (chartStyleSettings.isOneColor) {
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.one-color { fill:${chartStyleSettings.selectedLineColor.toRGB()}; }`;
            } else {
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.up-color { fill:${chartStyleSettings.selectedUpCandleColor.toRGB()}; }`;
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.down-color { fill:${chartStyleSettings.selectedDownCandleColor.toRGB()}; }`;
            }
        } else if (chartStyleSettings.chartType == ChartType.Bar) {
            if (chartStyleSettings.isOneColor) {
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.one-color { fill:${chartStyleSettings.selectedLineColor.toRGB()}; stroke:${chartStyleSettings.selectedLineColor.toRGB()}; }`;
            } else {
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.up-color { fill:${chartStyleSettings.selectedUpCandleColor.toRGB()}; stroke:${chartStyleSettings.selectedUpCandleColor.toRGB()}; }`;
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.down-color { fill:${chartStyleSettings.selectedDownCandleColor.toRGB()}; stroke:${chartStyleSettings.selectedDownCandleColor.toRGB()}; }`;
            }
        } else if (chartStyleSettings.chartType == ChartType.Line) {
            if (chartStyleSettings.isOneColor) {
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point { fill:${chartStyleSettings.selectedLineColor.toRGB()}; }`;
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-graph { stroke:${chartStyleSettings.selectedLineColor.toRGB()}; stroke-width:${chartStyleSettings.chartTypeLineWidth}px; }`;
            } else {
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-graph.zone-up-color { stroke:${chartStyleSettings.selectedUpCandleColor.toRGB()}; stroke-width:${chartStyleSettings.chartTypeLineWidth}px; }`;
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-graph.zone-down-color { stroke:${chartStyleSettings.selectedDownCandleColor.toRGB()}; stroke-width:${chartStyleSettings.chartTypeLineWidth}px; }`;

                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.zone-up-color { fill:${chartStyleSettings.selectedUpCandleColor.toRGB()}; stroke:${chartStyleSettings.selectedUpCandleColor.toRGB()}; }`;
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.zone-down-color { fill:${chartStyleSettings.selectedDownCandleColor.toRGB()}; stroke:${chartStyleSettings.selectedDownCandleColor.toRGB()}; }`;
            }
        } else if (chartStyleSettings.chartType == ChartType.HLC || chartStyleSettings.chartType == ChartType.OHLC) {
            if (chartStyleSettings.isOneColor) {
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.one-color { stroke:${chartStyleSettings.selectedLineColor.toRGB()}; stroke-width:${chartStyleSettings.chartTypeLineWidth}px; }`;
            } else {
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.up-color { stroke:${chartStyleSettings.selectedUpCandleColor.toRGB()}; stroke-width:${chartStyleSettings.chartTypeLineWidth}px; }`;
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.down-color { stroke:${chartStyleSettings.selectedDownCandleColor.toRGB()}; stroke-width:${chartStyleSettings.chartTypeLineWidth}px; }`;
            }
            
            for (let i = 0; i < chartStyleSettings.goLevelColors.length; i++) {
                const color = chartStyleSettings.goLevelColors[i];
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.go-level-${i} { stroke:${color}; }`;
            }
        } else if (chartStyleSettings.chartType == ChartType.Area) {
            if (chartStyleSettings.isOneColor) {
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point { fill:none; stroke-width: 0; }`;
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-graph { stroke:${chartStyleSettings.selectedLineColor.toRGB()}; stroke-width:${chartStyleSettings.chartTypeLineWidth}px; }`;

                if (chartStyleSettings.isGradientAreaColorChecked) {
                    styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-area { fill-opacity: 1; stroke:${chartStyleSettings.selectedLineColor.toRGB()}; fill:url(#tichart-area-bg${(this.isPnPMode ? '-pnp-' + this.chartId  : '-' + this.chartId )}); }`;
                } else {
                    styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-area { fill-opacity: 1; stroke:${chartStyleSettings.selectedLineColor.toRGB()}; fill:${chartStyleSettings.selectedLineColor.toRGBA(0.3)}; }`;
                }
            } else {
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-area { fill-opacity: 0; }`;
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-graph.zone-up-color { stroke:${chartStyleSettings.selectedUpCandleColor.toRGB()}; stroke-width:${chartStyleSettings.chartTypeLineWidth}px; }`;
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-graph.zone-down-color { stroke:${chartStyleSettings.selectedDownCandleColor.toRGB()}; stroke-width:${chartStyleSettings.chartTypeLineWidth}px; }`;

                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.zone-up-color { fill:${chartStyleSettings.selectedUpCandleColor.toRGB()}; stroke:${chartStyleSettings.selectedUpCandleColor.toRGB()}; }`;
                styleTag += `${this.chartStylePrefix} .${this.highChartBuilder.mainSeriesClassName} .highcharts-point.zone-down-color { fill:${chartStyleSettings.selectedDownCandleColor.toRGB()}; stroke:${chartStyleSettings.selectedDownCandleColor.toRGB()}; }`;
            }
        }

        if (chartStyleSettings.isOneColor) {
            styleTag += `${this.chartStylePrefix} .tooltip.one-color { border-color:${chartStyleSettings.selectedLineColor.toRGB()}; }`;
            styleTag += `${this.chartStylePrefix} .tooltip.one-color .dot { background-color:${chartStyleSettings.selectedLineColor.toRGB()}; }`;
        } else {
            styleTag += `${this.chartStylePrefix} .tooltip.up-color { border-color:${chartStyleSettings.selectedUpCandleColor.toRGB()}; }`;
            styleTag += `${this.chartStylePrefix} .tooltip.up-color .dot { background-color:${chartStyleSettings.selectedUpCandleColor.toRGB()}; }`;
            
            styleTag += `${this.chartStylePrefix} .tooltip.down-color { border-color:${chartStyleSettings.selectedDownCandleColor.toRGB()}; }`;
            styleTag += `${this.chartStylePrefix} .tooltip.down-color .dot { background-color:${chartStyleSettings.selectedDownCandleColor.toRGB()}; }`;
        }

        styleTag += `${this.chartStylePrefix} .highcharts-xaxis-labels text {fill: ${chartStyleSettings.selectedDateTextColor.toRGB()}}`;
        styleTag += `${this.chartStylePrefix} .highcharts-yaxis-labels text {fill: ${chartStyleSettings.selectedPriceTextColor.toRGB()}}`;
        
        styleTag += `</style>`;

        const chartStyleContainer = `<div class="ti-chart-style">${styleTag}</div>`;
        this.element.insertAdjacentHTML('afterbegin', chartStyleContainer);
    }

    public createIndicatorStyle(rawDatas: Array<TIIndicatorDataModel>) {
        let highChartIndicatorsStyle = this.element.querySelector('.ti-chart-indicators-style');
        if (highChartIndicatorsStyle) {
            highChartIndicatorsStyle.remove();
        }

        let styleTag = `<style>`;
        for (const rawData of rawDatas) {
            const needFill = rawData.chartType == 'column';
            const needStrokeWidth = rawData.chartType == 'line' || rawData.chartType == 'spline'; 
            if (rawData.colorType == IndicatorColorType.One) {
                styleTag += `${this.chartStylePrefix} .${rawData.getClassName()} { stroke:${rawData.color} !important; ${needFill ? 'fill:' + rawData.color + ' !important;' : ''}}`;
                if (needStrokeWidth) {
                    styleTag += `${this.chartStylePrefix} .${rawData.getClassName()} .highcharts-graph { stroke-width: 2px;}`;
                }
            } else {
                for (let i = 0; i < rawData.colors.length; i++) {
                    styleTag += `${this.chartStylePrefix} .${rawData.colors[i].className} { stroke:${rawData.colors[i].color} !important; ${needFill ? 'fill:' + rawData.colors[i].color + ' !important;' : ''} ${needStrokeWidth ? 'stroke-width: 2px;' : ''}}`;
                }
            }

            if (rawData.childIndicators && rawData.childIndicators.length) {
                for (let i = 0; i < rawData.childIndicators.length; i++) {
                    const childRawData = rawData.childIndicators[i];
                    const childNeedFill = childRawData.chartType == 'column';
                    const childNeedStrokeWidth = childRawData.chartType  == 'line' || rawData.chartType == 'spline'; 
                    if (childRawData.colorType == IndicatorColorType.One) {
                        styleTag += `${this.chartStylePrefix} .${childRawData.getClassName()} { stroke:${childRawData.color} !important; ${childNeedFill ? 'fill:' + childRawData.color + ' !important;' : ''}}`;
                        if (childNeedStrokeWidth) {
                            styleTag += `${this.chartStylePrefix} .${childRawData.getClassName()} .highcharts-graph { stroke-width: 2px;}`;
                        }
                    } else {
                        for (let j = 0; j < childRawData.colors.length; j++) {
                            styleTag += `${this.chartStylePrefix} .${childRawData.colors[j].className} { stroke:${childRawData.colors[j].color} !important; ${childNeedFill ? 'fill:' + childRawData.colors[j].color + ' !important;' : ''}  ${childNeedStrokeWidth ? 'stroke-width: 2px;' : ''}}`;
                        }
                    }
                }
            }
        }

        styleTag += `</style>`;

        const chartStyleContainer = `<div class="ti-chart-indicators-style">${styleTag}</div>`;
        this.element.insertAdjacentHTML('afterbegin', chartStyleContainer);
    }

    public createCrosshairsStyle(chartStyleSettings: ChartStyleSettingsModel) {
        let highChartStyle = this.element.querySelector('.ti-chart-cross-hairs-style');
        if (highChartStyle) {
            highChartStyle.remove();
        }

        let styleTag = `<style>`;
        if (chartStyleSettings.crossHairsEnabled) {
            styleTag += `${this.chartStylePrefix} .highchart-main-crosshair { display: block; stroke: #808080; }`;
        } else {
            styleTag += `${this.chartStylePrefix} .highchart-main-crosshair { visibility: hidden; opacity: 0; }`;
        }
        styleTag += `</style>`;

        const chartStyleContainer = `<div class="ti-chart-cross-hairs-style">${styleTag}</div>`;
        this.element.insertAdjacentHTML('afterbegin', chartStyleContainer);
    }

    public createGridLinesStyle(chartStyleSettings: ChartStyleSettingsModel) {
        let highChartStyle = this.element.querySelector('.ti-chart-grid-lines-style');
        if (highChartStyle) {
            highChartStyle.remove();
        }

        let styleTag = `<style>`;
        if (!chartStyleSettings.gridLinesEnabled) {
            styleTag += `${this.chartStylePrefix}  .highcharts-xaxis-grid .highcharts-grid-line { opacity: 0; }`;
            styleTag += `${this.chartStylePrefix}  .highcharts-yaxis-grid .highcharts-grid-line { opacity: 0; }`;
        }
        
        styleTag += `</style>`;

        const chartStyleContainer = `<div class="ti-chart-grid-lines-style">${styleTag}</div>`;
        this.element.insertAdjacentHTML('afterbegin', chartStyleContainer);
    }

    public createPlotbandsStyle(chartStyleSettings: ChartStyleSettingsModel) {
        let highChartStyle = this.element.querySelector('.ti-chart-plot-bands-style');
        if (highChartStyle) {
            highChartStyle.remove();
        }

        let styleTag = `<style>`;
        if (chartStyleSettings.showPreMarket) {
            styleTag += `${this.chartStylePrefix}  .pre-market-plot-band { fill: ${chartStyleSettings.preMarketColor.toRGB()}; }`;
        } else {
            styleTag += `${this.chartStylePrefix}  .pre-market-plot-band { display: none; }`;
        }

        if (chartStyleSettings.showPostMarket) {
            styleTag += `${this.chartStylePrefix}  .post-market-plot-band { fill: ${chartStyleSettings.postMarketColor.toRGB()}; }`;
        } else {
            styleTag += `${this.chartStylePrefix}  .post-market-plot-band { display: none; }`;
        }

        if (chartStyleSettings.isDarkTheme) {
            styleTag += `${this.chartStylePrefix}  .earning-notification-plot-band { fill: ${chartStyleSettings.earningRectangleColor.toRGB()}; fill-opacity: 0.15; }`;
        } else {
            styleTag += `${this.chartStylePrefix}  .earning-notification-plot-band { fill: ${chartStyleSettings.earningRectangleColor.toRGB()}; fill-opacity: 0.5; }`;
        }

        styleTag += `</style>`;

        const chartStyleContainer = `<div class="ti-chart-plot-bands-style">${styleTag}</div>`;
        this.element.insertAdjacentHTML('afterbegin', chartStyleContainer);
    }

    public createComparisonChartStyle(tiComparisionsData: Array<TIComparisonDataModel>) {
        let highChartStyle = this.element.querySelector('.ti-comparison-chart-style');
        if (highChartStyle) {
            highChartStyle.remove();
        }

        if (!tiComparisionsData.length) {
            return;
        }

        let styleTag = `<style>`;
        
        for (const comparisonData of tiComparisionsData) {
            styleTag += `${this.chartStylePrefix} .comparison-series-${comparisonData.symbol} .highcharts-point { display: none; }`;
            styleTag += `${this.chartStylePrefix} .comparison-series-${comparisonData.symbol} .highcharts-graph { stroke:${comparisonData.color.toRGB()}; }`;
        }

        styleTag += `</style>`;

        const chartStyleContainer = `<div class="ti-comparison-chart-style">${styleTag}</div>`;
        this.element.insertAdjacentHTML('afterbegin', chartStyleContainer);
    }

    public getTIChartBackgroundSVGDefs(chartStyleSettings: ChartStyleSettingsModel): SVGLinearGradientElement | null {
        if (chartStyleSettings.isGradientChecked) {
            const defTags = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
            defTags.setAttribute('x1', '0');
            defTags.setAttribute('y1', '0');
            defTags.setAttribute('x2', '0');
            defTags.setAttribute('y2', '1');
            defTags.setAttribute('id', 'tichart-bg' + (this.isPnPMode ? '-pnp-' + this.chartId  : '-' + this.chartId ));

            const stop1 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
            stop1.setAttribute('offset', '0');
            stop1.setAttribute('stop-opacity', '1');
            stop1.setAttribute('stop-color', chartStyleSettings.selectedChartBackgroundColor.toRGB());
            defTags.appendChild(stop1);

            const stop2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
            stop2.setAttribute('offset', '1');
            stop2.setAttribute('stop-opacity', '1');
            stop2.setAttribute('stop-color', chartStyleSettings.selectedChartGradientColor.toRGB());
            defTags.appendChild(stop2);
            
            return defTags;
        } 
        
        return null;
    }

    public getTIChartAreaBackgroundSVGDefs(chartStyleSettings: ChartStyleSettingsModel): SVGLinearGradientElement | null {
        if (chartStyleSettings.chartType == ChartType.Area && chartStyleSettings.isGradientAreaColorChecked) {
            if (this.isMarketingMode) {
                const lineColor1 = chartStyleSettings.marketingChartAreaFillHexColor;
                const lineColor2 = chartStyleSettings.marketingChartGradientHexColor;
    
                const defTags = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
                defTags.setAttribute('x1', '0');
                defTags.setAttribute('y1', '0');
                defTags.setAttribute('x2', '0');
                defTags.setAttribute('y2', '1');
                defTags.setAttribute('id', 'tichart-area-bg' + (this.isPnPMode ? '-pnp-' + this.chartId  : '-' + this.chartId ));
    
                const stop1 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                stop1.setAttribute('offset', '0');
                stop1.setAttribute('stop-opacity', '1');
                stop1.setAttribute('stop-color', lineColor1.toRGBA(0.3));
                defTags.appendChild(stop1);
    
                const stop2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                stop2.setAttribute('offset', '1');
                stop2.setAttribute('stop-opacity', '1');
                stop2.setAttribute('stop-color', lineColor2.toRGBA(0.3));
                defTags.appendChild(stop2);
            
                return defTags;
            } else {
                const lineColorHexLighten = chartStyleSettings.selectedLineColor.lighten(50);
                const lineColor2 = new ChartStyleColorModel(color.HEX2RGB(lineColorHexLighten));
    
                const defTags = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
                defTags.setAttribute('x1', '0');
                defTags.setAttribute('y1', '0');
                defTags.setAttribute('x2', '0');
                defTags.setAttribute('y2', '1');
                defTags.setAttribute('id', 'tichart-area-bg' + (this.isPnPMode ? '-pnp-' + this.chartId  : '-' + this.chartId ));
    
                const stop1 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                stop1.setAttribute('offset', '0');
                stop1.setAttribute('stop-opacity', '1');
                stop1.setAttribute('stop-color', chartStyleSettings.selectedLineColor.toRGBA(0.3));
                defTags.appendChild(stop1);
    
                const stop2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                stop2.setAttribute('offset', '1');
                stop2.setAttribute('stop-opacity', '1');
                stop2.setAttribute('stop-color', lineColor2.toRGBA(0.3));
                defTags.appendChild(stop2);
            
                return defTags;
            }
        }

        return null;
    }
}